const shareLinksClass = 'js-copy-to-clipboard';

document.addEventListener('click', e => {
	const target = e.target;
	if (target.classList.contains(shareLinksClass)) {
		e.preventDefault();
		console.log('test');
		copyToClipboard(target);
		showSuccessCopyTooltip();
	}
});

function showSuccessCopyTooltip() {
	const div = document.createElement('div');
	div.innerHTML = 'Copied to clipboard';
	div.classList.add('u-copy-tooltip');
	document.body.appendChild(div);
	setTimeout(() => {
		div.remove();
	}, 2000);
}

function copyToClipboard(item) {
	const href = item.getAttribute('href');

	// Copy the href to the clipboard using the Clipboard API
	if (navigator.clipboard) {
		navigator.clipboard.writeText(href).then(() => {
			showSuccessCopyTooltip();
		}).catch((error) => {
			console.error('Failed to copy link: ', error);
		});
	} else {
		const textarea = document.createElement('textarea');
		textarea.value = href;
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand('copy');
		document.body.removeChild(textarea);
		showSuccessCopyTooltip();
	}
}
